<!-- 卡片 -->
<template>
    <div class="cardItem" v-if="itemlist.length>0">
        <div class="item1" v-for="i in itemlist" :key="i" @click="gourl(i)" :style="{'animation-delay': `.${rang(5)}s`}">
            <div class="card_item1">
                <div class="item_img">
                    <img class="img1" :src="i.picurl" alt="">
                    <el-tooltip v-if="i.isagent===1" content="特殊" placement="top" class="box-item" effect="dark">
                        <img class="img2" src="@/assets/gantan.svg" alt="">
                    </el-tooltip>
                </div>
                <div class="item_rama">
                    <div class="card_name">{{ i.name }}</div>
                    <div class="card_ramadk">
                        <div v-for="j,index in i.typelist" :key="index" class="jie_item">
                            <div>{{ j }}</div>
                            <div v-if="index+1!==i.typelist.length" class="heng">|</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card_item2">{{ i.ramack }}</div>
        </div>
    </div>
    <div class="cardItem404" v-else>
        <img :src="p404" alt="">
    </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue'
import { useStore } from 'vuex';
import {Onclick} from '@/api'

const store = useStore()
const p404 = computed(()=>{return store.state.app.sysinfo.pic404url})
const itemlist = computed(()=>{return store.state.app.itemlist})

const gourl = (val)=>{
    Onclick(val.id).then().catch()
    // window.open(val.gourl)
}

const rang = (length)=>{
    const index = Math.floor(Math.random() * length);
    return index
}

</script>

<style lang="scss" scoped>
.cardItem{
    left: 50%;
    width: 100%;
    padding: 0 3rem;
    display: flex;
    flex-wrap: wrap;
    background: var(--bac-ground);
    padding-bottom: 5rem;
    .item1{
        width: 24rem;
        border-radius: 1rem;
        padding: 1.3rem 2rem;
        display: flex;
        flex-direction: column;
        border: 1px solid var(--carditem-item-border1);
        background: var(--carditem-item-bac);
        margin: 1rem .5rem;
        transition: opacity .2s ease-in;
        animation: itemin .4s ease-in forwards;
        opacity: 0;
        animation-delay: var(--s);
        cursor: pointer;
        .card_item1{
            flex:1;
            display: flex;
            margin: 1rem 0;
            .item_img{
                width: 3rem;
                height: 3rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: .85rem;
                background: var(--carditem-item-img-bac);
                position: relative;
                .img1{
                    width: 2rem;
                    border-radius: 10px;
                }
                .img2{
                    width: .6rem;
                    padding: .1rem;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    background: var(--carditem-item-img2-bac);
                    border-radius: 50%;
                }
            }
            .item_rama{
                margin-left: 1rem;
                display: flex;
                flex-direction: column;
                .card_name{
                    flex:1;
                    display: flex;
                    align-items: center;
                    color:var(--carditem-item-name);
                }
                .card_ramadk{
                    flex:1;
                    display: flex;
                    align-items: center;
                    .jie_item{
                        display: flex;
                        color:#b0b0b0;
                        font-size: .8rem;
                    }
                    .heng{
                        color:#b0b0b0;
                        margin: 0 10px;
                    }

                }
            }
        }
        .card_item2{
            flex:1;
            margin: .5rem 0;
            font-size: 13px;
            color:#b0b0b0;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;

        }
    }
    .item1:hover{
        background: var(--carditem-item-hover);
    }
}
.cardItem404{
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        animation: opacityAll .5s;
    }
}
</style>